/* Birthday Sale: the foil "5" balloon on the home hero (MDS turns five). Ported from the prototype's
   components/hero-balloon.js (v3 motion, Damien's pick; SPEC 8c). Loaded only by sections/mds-hm-hero.liquid while the
   sale hero is showing. It lives inside the hero photo card ([data-bds-hero-card]): with the studio cut-out scene the
   balloon and its string sit behind the products and the string is tethered behind the Flow Timer; with a photo it
   floats in the top-right of the card and the string runs out of the card's bottom edge.
   It bobs slowly, hover nudges it, a tap or Enter plays a small paper-confetti puff. Reduced motion: a still balloon,
   no puff. Assets come from the section's <script type="application/json" data-bds-balloon-assets>, else BDS.asset(). */
(function () {
  'use strict';
  var B = window.BDS;
  if (B && B.sale && B.sale.active === false) return;

  var RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var A = {};
  try { A = JSON.parse((document.querySelector('[data-bds-balloon-assets]') || {}).textContent || '{}'); } catch (e) { A = {}; }
  var asset = function (n) { return B && B.asset ? B.asset(n) : ''; };
  var BALLOON = A.balloon || asset('hero-bday/balloon-5-gold-body.png');
  var CONF = (A.confetti && A.confetti.length) ? A.confetti : Array.from({ length: 25 }, function (_, i) { return asset('hero-bday/confetti/' + String(i).padStart(2, '0') + '.png'); });
  if (!BALLOON) return;

  var css = '.bd{position:absolute;pointer-events:none}'
    + '.bd-clip{display:block !important;position:absolute;inset:0;overflow:hidden;border-radius:inherit;pointer-events:none}'
    + '.bd-hit{pointer-events:auto;cursor:pointer;-webkit-tap-highlight-color:transparent}'
    + '.bd-hit:focus-visible{outline:2px solid #5F7265;outline-offset:4px;border-radius:8px}'
    + '.bd-balloon img{display:block;width:100%;height:auto;filter:drop-shadow(6px 10px 10px rgba(41,38,33,.18))}'
    + '.bd-burst{position:absolute;transform:translate(-50%,-50%)}'
    + '@keyframes bdPuff{0%{opacity:0;transform:translate(-50%,-50%) rotate(0) scale(.7)}18%{opacity:.95}65%{opacity:.9}100%{opacity:0;transform:translate(calc(-50% + var(--dx)),calc(-50% + var(--dy) + 10px)) rotate(var(--r)) scale(1)}}'
    + '.bd-puff.go{animation:bdPuff 1.3s cubic-bezier(.25,.6,.35,1) forwards}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var rnd = function (a, b) { return a + Math.random() * (b - a); };
  // layout as fractions of the card: x = the balloon's centre, top = its top edge, w = its width (v3 values)
  var L = { desktop: { x: 0.835, top: 0.025, w: 0.155 }, mobile: { x: 0.862, top: 0.03, w: 0.165 } };
  // the "5" body: aspect ratio, knot position (fraction of width), string length vs body height, width factor
  var T = { ar: 251 / 424, kx: 0.49, len: 0.442 / 0.558, wk: 251 / 284 };

  var busy = false, built = [];
  function play(ms, fn) { if (busy || RM) return; busy = true; fn(); setTimeout(function () { busy = false; }, ms); }
  function clear() { built.forEach(function (n) { if (n.__stop) n.__stop(); n.remove(); }); built = []; }

  function build() {
    var card = document.querySelector('[data-bds-hero-card]');
    if (!card) return;
    clear();
    var W = card.clientWidth, H = card.clientHeight;
    if (!W || !H) return;
    var C = L[innerWidth < 750 ? 'mobile' : 'desktop'];
    var scene = card.querySelector('.bds-hs') || card;
    if (getComputedStyle(scene).position === 'static') scene.style.position = 'relative';
    var cr = card.getBoundingClientRect(), sr = scene.getBoundingClientRect();
    var ox = cr.left - sr.left, oy = cr.top - sr.top;
    var bw = C.w * W * T.wk, bh = bw / T.ar;
    var left0 = ox + C.x * W - bw / 2, top0 = oy + C.top * H;
    var K0 = { x: left0 + T.kx * bw, y: top0 + bh };
    // tether: behind the Flow Timer when the cut-out scene is there (its end is hidden), else past the card's bottom edge
    var bundle = scene.querySelector('.bds-hs__bundle');
    var anchor;
    if (bundle) {
      var pb = bundle.getBoundingClientRect();
      anchor = { x: K0.x + bw * 0.03, y: Math.max(K0.y + bh * T.len, pb.top - sr.top + pb.height * 0.62) };
    } else {
      anchor = { x: K0.x + bw * 0.06, y: oy + H + 8 };
    }
    var s = W / 617;
    var behind = !!bundle;
    if (behind) scene.querySelectorAll('img').forEach(function (i) { i.style.zIndex = 1; });

    var NS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(NS, 'svg');
    svg.setAttribute('class', 'bd bd-string'); svg.setAttribute('aria-hidden', 'true');
    svg.style.cssText = 'left:0;top:0;width:100%;height:100%;overflow:visible;display:block;z-index:' + (behind ? 0 : 2);
    var path = document.createElementNS(NS, 'path');
    path.setAttribute('fill', 'none'); path.setAttribute('stroke', 'rgba(168,158,143,.8)');
    path.setAttribute('stroke-width', Math.max(0.8, 1.1 * s)); path.setAttribute('stroke-linecap', 'round');
    svg.appendChild(path);

    var b = document.createElement('div');
    b.className = 'bd bd-balloon bd-hit';
    b.style.cssText = 'display:block;width:' + bw + 'px;height:' + bh + 'px;left:' + left0 + 'px;top:' + top0 + 'px;z-index:' + (behind ? 0 : 3) + ';transform-origin:' + (T.kx * 100) + '% 100%;will-change:transform';
    b.innerHTML = '<img src="' + BALLOON + '" alt="" width="251" height="424">';
    b.setAttribute('role', 'button'); b.setAttribute('aria-label', 'Birthday balloon'); b.tabIndex = 0;
    scene.insertBefore(svg, scene.firstChild); scene.insertBefore(b, svg.nextSibling); built.push(svg, b);

    var nx = 0, nv = 0, cpx = (anchor.x + K0.x) / 2, cpy = (anchor.y + K0.y) / 2, last = performance.now(), t0 = last, running = true, visible = true;
    var draw = function (kx, ky) { path.setAttribute('d', 'M' + anchor.x.toFixed(1) + ',' + anchor.y.toFixed(1) + ' Q' + cpx.toFixed(1) + ',' + cpy.toFixed(1) + ' ' + kx.toFixed(1) + ',' + ky.toFixed(1)); };
    if (RM) {
      draw(K0.x, K0.y);
    } else {
      var TAU = Math.PI * 2;
      var frame = function (now) {
        if (!running) return;
        var dt = Math.min(0.05, (now - last) / 1000); last = now; var t = (now - t0) / 1000;
        // ambient: slow, layered, never in sync, so it never reads as a loop
        var dy = 4.5 * s * Math.sin(TAU * t / 5.2), dx = 3 * s * Math.sin(TAU * t / 6.3 + 1.1);
        // nudge spring (underdamped, settles in about 2.5s)
        nv += (-7 * nx - 2.2 * nv) * dt; nx += nv * dt;
        var rot = 1.4 * Math.sin(TAU * t / 5.8 + 0.6) + nx / s * 0.35;
        b.style.transform = 'translate(' + (dx + nx).toFixed(2) + 'px,' + dy.toFixed(2) + 'px) rotate(' + rot.toFixed(2) + 'deg)';
        var kx = K0.x + dx + nx, ky = K0.y + dy;
        // the string's control point eases toward a point below the knot, so the curve trails the balloon
        var tx = kx + (anchor.x - kx) * 0.45 - (dx + nx) * 0.6, ty = ky + (anchor.y - ky) * 0.5;
        var f = 1 - Math.pow(0.02, dt); cpx += (tx - cpx) * f; cpy += (ty - cpy) * f;
        draw(kx, ky);
        if (visible && !document.hidden) requestAnimationFrame(frame); else running = false;
      };
      var start = function () { if (running) return; running = true; last = performance.now(); requestAnimationFrame(frame); };
      requestAnimationFrame(frame);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es.some(function (e) { return e.isIntersecting; }); if (visible) start(); }).observe(card);
      document.addEventListener('visibilitychange', function () { if (!document.hidden && visible) start(); });
      b.__stop = function () { running = false; };
    }
    var nudge = function (dir) { if (!RM) nv += dir * 38 * s; };
    // a few paper flecks drift up and out from beside the balloon and fade: slow, small, inside the card
    var puff = function () {
      play(1400, function () {
        var clip = document.createElement('div'); clip.className = 'bd-clip'; clip.style.zIndex = 5; card.appendChild(clip);
        var px = C.x * W, py = C.top * H + bh * 0.45;
        for (var k = 0; k < 7; k++) {
          var ang = rnd(-160, -20) * Math.PI / 180, dist = rnd(0.035, 0.075) * W;
          var n = document.createElement('div'); n.className = 'bd-burst bd-puff';
          n.innerHTML = '<img src="' + CONF[(k * 4 + 1) % CONF.length] + '" alt="" style="width:100%;display:block">';
          n.style.width = rnd(0.014, 0.022) * W + 'px';
          n.style.left = (px + Math.cos(ang) * bw * 0.45) + 'px'; n.style.top = (py + Math.sin(ang) * bh * 0.3) + 'px';
          n.style.setProperty('--dx', Math.cos(ang) * dist + 'px'); n.style.setProperty('--dy', Math.sin(ang) * dist * 0.7 + 'px'); n.style.setProperty('--r', rnd(-120, 120) + 'deg');
          n.style.animationDelay = rnd(0, 0.15) + 's'; clip.appendChild(n);
          (function (el) { requestAnimationFrame(function () { el.classList.add('go'); }); })(n);
        }
        setTimeout(function () { clip.remove(); }, 1500);
      });
    };
    var lastNudge = 0;
    b.addEventListener('mouseenter', function (e) {
      if (!matchMedia('(hover: hover)').matches || performance.now() - lastNudge < 900) return;
      lastNudge = performance.now(); var r = b.getBoundingClientRect(); nudge(e.clientX < r.left + r.width / 2 ? 1 : -1);
    });
    b.addEventListener('click', function (e) { var r = b.getBoundingClientRect(); nudge(e.clientX && e.clientX > r.left + r.width / 2 ? -1 : 1); puff(); });
    b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); nudge(1); puff(); } });
  }

  function go() { build(); window.addEventListener('load', build); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(build, 150); });
})();
